import { httpHelper } from "@/_shared/utils";

const buildForContactForm = (id = 1, tableName = 'providers') =>
  `${process.env.BACKEND_URL}/records/${tableName}/${id}?join=requisites`;

const buildForProductsTab = (providerId = 1, removingProducts = []) => {
  const baseUrl = `${process.env.BACKEND_URL}/records/products_providers`;
  const filterParam = `filter=provider_id,eq,${providerId}`;
  let fullUrl = `${baseUrl}?${filterParam}`;
  if (removingProducts.length > 0) {
    const excludedIds = removingProducts.map(({ provider_product_id }) => (
      provider_product_id
    ));
    fullUrl += `&filter=id,nin,${excludedIds.join(',')}`;
  }
  fullUrl = httpHelper.joinStockEntities(fullUrl);
  return fullUrl;
};

const urlBuilder = {
  buildForContactForm,
  buildForProductsTab,
};

export default urlBuilder;



// WEBPACK FOOTER //
// ./src/business/api-services/_urlBuilder.js